import { useState } from 'react';

import FileUpload from 'shared/molecules/FileUpload';

import type { FormFieldProperties } from '../FormInput';

interface FormImageProps {
  name: string;
  onCompleteUpload?: () => void;
  onStartUpload?: () => void;
  properties?: Record<string, FormFieldProperties>;
  required?: boolean;
}

const FormImage = ({
  name,
  onCompleteUpload,
  onStartUpload,
  properties = {},
  required: requiredProp,
  ...props
}: FormImageProps) => {
  const { disabled, required } = properties[name] || {};
  const [submitting, setSubmitting] = useState(false);

  const handleStartUpload = () => {
    setSubmitting(true);
    if (onStartUpload) {
      onStartUpload();
    }
  };

  const handleCompleteUpload = () => {
    setSubmitting(false);
    if (onCompleteUpload) {
      onCompleteUpload();
    }
  };

  return (
    <FileUpload
      disabled={disabled || submitting}
      isRequired={requiredProp === undefined ? required : requiredProp}
      onStartUpload={handleStartUpload}
      onCompleteUpload={handleCompleteUpload}
      {...props}
    />
  );
};

export default FormImage;
export type { FormImageProps };
